import { render, staticRenderFns } from "./BroadcastRow.vue?vue&type=template&id=4559d9dd&scoped=true&"
import script from "./BroadcastRow.vue?vue&type=script&lang=js&"
export * from "./BroadcastRow.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastRow.vue?vue&type=style&index=0&id=4559d9dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4559d9dd",
  null
  
)

export default component.exports